import { render, staticRenderFns } from "./DxField.vue?vue&type=template&id=bf8a444a"
import script from "./DxField.vue?vue&type=script&lang=js"
export * from "./DxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports